import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface BasicInfo {
  name?: string;
  acceptedName?: string;
  desc?: string;
  categoryId?: number;
  subCategoryId?: number;
  price?: number;
  weightedGPA?:number;
  tutorId?: number;
  tutorName?:string;
  subjects?: string;
  startDate?: string | null;
  endDate?: string | null;
  duration?: string;
  location?: 'online' | 'in person';
  address?: string;
}

interface Content {
  id?: number;
  content: string;
  materials: string;
  certificate: string;
  duration: string;
  lessons: number;
  examCount: number;
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  maxStudent: number;
  location: 'online' | 'in person';
  address: string;
  grade: string;
  courseId?: number;
}

interface Setting {
  isQuiz: boolean;
  isPublish: boolean;
  isRecurring: boolean;
  startDate: string;
  endDate: string;
}

interface CourseState {
  basicInfo: BasicInfo | null;
  content: Content | null;
  setting: Setting | null;
  availabilityInfo: AvailabilityInfo | null;
}

const initialState: CourseState = {
  basicInfo: null,
  content: null,
  setting: null,
  availabilityInfo: null
};

export interface AvailabilityInfo {
  dateRangeInfo: {
    fromDate: string;
    toDate: string;
  };
  dayTimeSlots: Array<{
    day: string;
    timeSlots: Array<{
      startTime: string;
      endTime: string;
      status: string;
    }>;
  }>;
}
const courseSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {
    updateBasicInfo: (state, action: PayloadAction<BasicInfo>) => {
      state.basicInfo = action.payload;
    },
    updateContent: (state, action: PayloadAction<Content>) => {
      state.content = action.payload;
    },
    updateSetting: (state, action: PayloadAction<Setting>) => {
      state.setting = action.payload;
    },
   updateAvailabilityInfo: (
      state,
      action: PayloadAction<AvailabilityInfo>
    ) => {
      state.availabilityInfo = action.payload;
    },
    clearCourseData: state => {
      state.basicInfo = null;
      state.content = null;
      state.setting = null;
      state.availabilityInfo = null; 
    },
  },
});

export const {updateBasicInfo, updateContent, updateSetting, updateAvailabilityInfo, clearCourseData} = courseSlice.actions;
export default courseSlice.reducer;
